import IconJobFlex from 'assets/icon/ic_jobflex.png'
import Expect from 'assets/img/login/expect.png'
import LoginDraftBg from 'assets/img/login/login_draft_bg.png'
import Footer, { FooterMode } from 'components/Footer'
import Frame from 'components/Frame'
import JobFlexPrivacyTerms from 'components/JobFlexPrivacyTerms'
import Modal from 'components/Modal'
import SiriWave from 'components/siriWave'
import colors from 'const/style/colors'
import fonts from 'const/style/fonts'
import UserStatusType from 'consts/UserStatusType'
import { inject, observer } from 'mobx-react'
import Login from 'models/Login'
import React, { FC, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, withRouter } from "react-router-dom"
import styled from 'styled-components'
import Loading from 'components/Loading'
const LoginPageFrame = styled(Frame)`
    text-rendering: optimizeLegibility;
    font-size: 13px;
    font-style: normal;
    letter-spacing: -0.1;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background:#F0F3FA;

      
    .jobflex-logo{
    position: fixed;
    top: 0%;
    left: 0%;
    margin:30px;
    }

    .frame-footer {
    position:fixed;
    bottom:0;
    .btn-privacy {
        color:#5758C7;
    }
  }

`

const LoginFrame = styled.div`
    position: relative;
    top: 50%;
    left: 50%;
    width: 1090px;
    height: 620px;
    transform: translate(-50%, -50%);
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 30px 50px;
    display:flex;
    flex-direction:row;
    button{
    border: 0;
    background: transparent;
    padding: 0;
    outline: none;
    text-rendering: optimizeLegibility;
    font-size: 13px;
    font-style: normal;
    line-height: 135%;
    box-sizing: border-box;
    cursor: default;
    }

    .left-main-frame{
 
    width: 347px;
    height: 620px;
    }

    .right-main-frame{
   
    position: relative;
    width: 743px;
    height: 620px;

    .bg-frame{
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(${LoginDraftBg}) center center / contain;
    opacity: 1;
    }
    .yourself-frame{
        position: absolute;
         width: 100%;
         height: 100%;
        position: absolute;
        margin-top: 150px;
        div{
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: ${colors.CFFFFFF};
        }
     }
    
     .pangpang-wrapper{
        margin-top:40px;
     }
    }


    .logo-script-frame{
    width: 100%;
    margin-top:100px;
    padding-left:50px;
    padding-right:50px;
        .logo{
            width: 100%;
            height:100%;
            background:transparent;
            text-align: left;
            margin-bottom: 25px;
                img{
                    width: 100%;
                    background-size:contain;
                }
        }
        .script{
            width: 243px;
            font-size: 13px;
            font-weight: bold;
            color: rgb(11, 11, 12);
            text-align:left;
        }
    }

    .login-frame{
        padding-left:50px;
        padding-right:50px;

        .INTERVIEW_LOGIN_INPUT{
            margin-top: 45px;
             opacity: 1;
            display: block;
            width: 242px;
            height: 40px;
            border-top-style: initial;
            border-right-style: initial;
            border-left-style: initial;
            border-top-color: initial;
            border-right-color: initial;
            border-left-color: initial;
            font-size: 15px;
            font-weight: bold;
            color: rgb(11, 11, 12);
            outline: none;
            /* transition: background 0.5s ease 0s; */
            border-width: 0px 0px 1px;
            border-bottom: 1px solid rgb(226, 226, 231);
            border-image: initial;
            background: transparent;
        }
        .login-submit{
            margin-top: 45px;
            opacity: 1;
            color: rgb(255, 255, 255);
            font-size: 17px;
            width: 243px;
            height: 54px;
            cursor: pointer;
            /* transition: transform 0.3s ease 0s, background 0.5s ease 0s; */
            border-radius: 2px;
            background: rgb(87, 88, 199);
        }
    }
`
const InfoAgreeFrame = styled.div`
 
    width: 480px;
    height: 600px;
    line-height: 20px;
    background:${colors.CFFFFFF};
    text-align:left;
    box-shadow: 0px 11px 27px ${colors.C00000033};
       .title{
        text-align:left;
            padding: 16px 20px 18px 25px;
            background: rgb(87, 87, 186);
            font-size: 20px;
            color: rgb(255, 255, 255);
            line-height: 18px;
            font-weight: bold;
        }

        .info-title{
            padding: 16px 20px 16px 25px;
            font-weight: bold;
            font-size: 18px;
        }
        .info-content{
            overflow-y:scroll;
            height:350px;
            margin: 5px 25px 18px 25px;
            background: rgb(245, 245, 252);
            &::-webkit-scrollbar
            {
                width: 8px;
                background-color: rgb(245, 245, 252);
                padding-right:1px;
            }
            &::-webkit-scrollbar-track {
                background-color: rgb(245, 245, 252);
            }

            &::-webkit-scrollbar-thumb
            {
                background-color: #B3B3C7;
                border-radius: 8px;
            }

                 

        }
        .agree{
            text-align:center;
                label{
                    cursor: pointer;
                }
                div{
                    display: inline-block;
                     font-size: 16px; 
                     margin-left: 10px;
                      font-weight: bold;
                }
            }
            .ageree-btn{
               text-align:center;
                div{
                    margin-top: 26px;
                margin-bottom: 30px;
                display: inline-block;
                cursor: pointer;
                font-weight: bold;
                font-size: 15px;
                color: rgb(255, 255, 255);
                border-radius: 2px;
                background: rgb(87, 87, 186);
                padding: 10px 30px 12px;  
                }
            }
`
const ErrorModalFrame = styled.div`
     min-width:500px;
    min-height:200px;
    padding-top:57px;
    padding-bottom:50px;
    background:${colors.CFFFFFF};
    text-align:center;
    box-shadow: 0px 11px 27px ${colors.C00000033};
    white-space:pre;
    ${fonts.H2_Bold};

  .btn-cta {
    width:200px;
    height:40px;
    background-color:${colors.C2E303C};
    ${fonts.H2_White};
    border-radius:5px;
    margin-top:26px;
    cursor:pointer;
  }
`

interface ILoginProps {
    loginInfo?: Login;
}


const LoginPage: FC<ILoginProps> = (props: ILoginProps) => {
    const { loginInfo }: ILoginProps = props;
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isAgreeCheck, setIsAgreeCheck] = useState<boolean>(false);
    const [isAgreeCheckView, setIsAgreeCheckView] = useState<boolean>(false);




    const onSubmit = async(data: any) => {
        await loginInfo!.login(data);
        if(loginInfo!.userInfo!.isAgreePrivacyPolicy==='Y'){
            process.env.REACT_APP_ENV === 'development' ?history.push('/home'): loginInfo!.goCalibration();
        }
    }

    const onAgreeSubmit = async (data: any) => {

        if (isAgreeCheck) {

            await loginInfo!.setPrivacyPolicy();
            if(loginInfo?.userInfo?.userStatusType !== UserStatusType.PDF_UPLOAD && loginInfo?.userInfo?.userStatusType !== UserStatusType.COMPLETED)
                await loginInfo!.updateUserStatusType(UserStatusType.START);
            process.env.REACT_APP_ENV === 'development' ?
                history.push('/home')
                : loginInfo!.goCalibration();
            //    :history.push('/calibration')
            //    window.open('http://localhost:8080/calibration',"_self");
        } else {
            setIsAgreeCheckView(true);
        }
    }

    if (!loginInfo) throw new Error('no loginInfo Found');
    if (!loginInfo) throw new Error('no loginInfo Found');

    useEffect(() => {
        const init = async () => {
            if (window.calibration) {
                await loginInfo.loginCheck();
                await loginInfo.getUserInfo();
                if(loginInfo.userInfo?.userStatusType === UserStatusType.PDF_UPLOAD) 
                    history.replace('/continuePT');
                else
                    history.replace('/home');
            }
            setIsLoading(false);
        }
        init();

    }, []);

    return (
        <LoginPageFrame>
            <img className='jobflex-logo' src={IconJobFlex}></img>

            <LoginFrame>
                <div className='left-main-frame'>
                    <div className='logo-script-frame'>
                        <div className='logo'>
                            {loginInfo.companyInfo ? <img src={`${loginInfo.companyInfo!.logo}`} /> : <img></img>}
                        </div>
                        <div className='script'>하단 로그인 버튼을 눌러주세요.</div>
                    </div>
                    <div className='login-frame'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input placeholder="이름" name='name' className='INTERVIEW_LOGIN_INPUT' ref={register}></input>
                            <input placeholder="인증코드" name='userCk' className='INTERVIEW_LOGIN_INPUT' ref={register}></input>
                            <button type='submit' className='login-submit'>Login</button>
                        </form>
                    </div>
                </div>
                <div className='right-main-frame'>
                    <div className='bg-frame'></div>
                    <div className='yourself-frame'>
                        <img src={Expect}></img>
                    </div>
                    {/* <img className='pangpang' src={PangPnag}></img> */}
                    <SiriWave ratio={0.625}></SiriWave>
                </div>
            </LoginFrame>
            <Modal
                open={loginInfo.isLogin && loginInfo!.userInfo!.isAgreePrivacyPolicy==='N'}
                // open={true}
                frame={false}>
                <InfoAgreeFrame
                >
                    <div className='title'>개인정보 수집 및 이용에 관한 동의</div>
                    <div className='info-title'></div>
                    <div className='info-content'>
                        <JobFlexPrivacyTerms></JobFlexPrivacyTerms>
                    </div>
                    <div className="agree">
                        <input id="agree-check" type="checkbox" onChange={(data: any) => {
                            if (data.target.checked) setIsAgreeCheck(true);
                            else setIsAgreeCheck(false);
                        }}></input>
                        <label htmlFor="agree-check">
                            <div >본인은 위 내용을 잘 읽어 보았으며 내용에 동의합니다.</div>
                        </label>
                    </div>
                    <div className="ageree-btn">
                        <div onClick={onAgreeSubmit}>동의 및 온라인 PT 시작하기</div>
                    </div>
                </InfoAgreeFrame>
                <Modal open={isAgreeCheckView}>
                    <h2>동의하지 않으면 전형을 진행할 수 없습니다.</h2>
                    <button className='btn-cta' onClick={() => {
                        setIsAgreeCheckView(false);

                    }}>확인</button>
                </Modal>
            </Modal>
            <Modal open={loginInfo.isError}>
                <h2>{loginInfo.errorMsg}</h2>
                <button className='btn-cta' onClick={() => loginInfo.isError = false}>확인</button>
            </Modal>
            <Footer 
            mode={FooterMode.WHITE} />
            {isLoading && <Loading></Loading>}
        </LoginPageFrame>
    )

}

export default withRouter((inject('loginInfo')(observer(LoginPage))) as any);